/** 被嵌侧门面：独立打开时保持 app 默认主题，被可信宿主内嵌时接收并应用其主题 */
import { getThemeRuntime } from './runtime/runtime';
import { createThemeClient } from './bridge/protocol';
import { parseThemeOrigins } from './core/validate';
import type { IThemeBridgeOptions, ThemeVantPresetType } from './types';

export interface IEmbedThemeOptions extends IThemeBridgeOptions {
  vant: ThemeVantPresetType;
}

let dispose: (() => void) | undefined;

/** 在入口 router 安装 / mount 前调用一次；重复调用返回同一个 dispose */
export function installEmbedTheme(options: IEmbedThemeOptions): () => void {
  if (dispose) return dispose;
  const runtime = getThemeRuntime({ vant: options.vant });
  const disposeClient = createThemeClient({
    allowAnyOrigin: options.dev,
    debug: options.dev,
    trustedOrigins: parseThemeOrigins(options.trustedOrigins),
    // 宿主未下发的 token 回退本端默认值
    apply: runtime.apply,
    reset: runtime.reset
  });
  dispose = () => {
    disposeClient();
    dispose = undefined;
  };
  return dispose;
}
